/*=============================================== Wrapper ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
import styled from "styled-components";
import Variables from "./Variables";
/*==================== Component ====================*/
var Wrapper = function (_a) {
    var template = _a.template, children = _a.children, props = __rest(_a, ["template", "children"]);
    return (React.createElement(Container, __assign({ "$template": template }, props), children));
};
export default Wrapper;
/*==================== Types ====================*/
var common = {
    "1col": "1col",
    "2cols": "2cols",
    "3cols": "3cols",
};
/*==================== Styles ====================*/
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: grid;\n    grid-template-columns: ", ";\n    gap: ", ";\n    position: relative;\n    z-index: 10;\n    background-color: ", ";\n"], ["\n    display: grid;\n    grid-template-columns: ", ";\n    gap: ", ";\n    position: relative;\n    z-index: 10;\n    background-color: ", ";\n"])), function (_a) {
    var $template = _a.$template;
    return $template === "2cols"
        ? Variables.Layouts.Wrapper.TwoCols
        : $template === "3cols"
            ? Variables.Layouts.Wrapper.ThreeCols
            : Variables.Layouts.Wrapper.OneCol;
}, Variables.Spacers.L, Variables.Colors.Background);
var templateObject_1;
